/**
 * This file should contain those methods which are only related to table management
 */

import DinningPlace from "../component/table/DinningPlace";
import LayoutTabsCustomLable from "../component/table/LayoutTabsCustomLabel";
import { TABLE_STATUS_COLORS } from "../constant/constants";
import ApiService from "../utils/ApiService";
import { getOrCreateSessionId } from "../utils/Common";
import { replaceSelectedTablesInStore, updateTableManagementStore } from "../utils/store-mutator.table-management";

export const getTableStatusColor = (status) => {
  switch (status) {
    case "Available":
      return TABLE_STATUS_COLORS.AVAILABLE;
    case "Reserved":
      return TABLE_STATUS_COLORS.RESERVED;
    case "On Dine":
      return TABLE_STATUS_COLORS.ON_DINE;
    case "Occupied":
      return TABLE_STATUS_COLORS.OCCUPIED;
    default:
      return "#eee";
  }
};

export const getQueryParamsPaymentForm = () => {
  const queryParams = new URLSearchParams(window.location.search);
    const tableManagement = queryParams.get("tablemanagement");
  const takeout = queryParams.get("takeout");

  return {
    isTableManagement: tableManagement === "Active",
    isTakeout: takeout === "Yes",
    orderPageNo: queryParams.get("pageNo"),
    sourcePage: queryParams.get("sourcePage"),
    dataSource: queryParams.get("data-source"),
    destination: queryParams.get("destination"),
  };
};

export const getQueryParamsTableLayout = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const sessionId = queryParams.get("session-id");

  return {
    sessionId,
    shouldRemoveSessionId: sessionId ? false : true,
  };
};

export const getSelectedTableIds = (idWiseSelectedTables) => {
  const sessionId = getOrCreateSessionId();

  if (!sessionId || !idWiseSelectedTables.hasOwnProperty(sessionId)) {
    return [];
  }

  return idWiseSelectedTables[sessionId].map((item) => item.tableId);
};

export const getActiveButtonOrderFooter = () => {
  const pathName = window.location.pathname;

  if (["/table"].includes(pathName)) {
    return "TABLE";
  }

  if (["/order/add"].includes(pathName) || pathName.match(/^\/order\/([0-9a-fA-F]{24})\/edit$/)) {
    return "ORDER";
  }

  if (pathName.match(/^\/order\/([0-9a-fA-F]{24})\/payment$/)) {
    return "PAYMENT";
  }

  return "";
};

export const shouldEnablePaymentButtonTableSystem = () => {
  const pathName = window.location.pathname;

  if (pathName.match(/^\/order\/([0-9a-fA-F]{24})\/edit$/)) {
    return true;
  }

  if (pathName.match(/^\/order\/([0-9a-fA-F]{24})\/split-bill$/)) {
    return true;
  }

  return false;
};

export const shouldDisableHamburgerIcon = (orderStatus = '') => {
  console.log('---------------shouldDisableHamburgerIcon----------------', {orderStatus});
  const pathName = window.location.pathname;

  if (["/order/add"].includes(pathName)) {
    return true;
  }

  if (orderStatus.toLocaleLowerCase() === 'pending') {
    return true;
  }

  const queryParams = new URLSearchParams(window.location.search);
  const takeout = queryParams.get("takeout");
  
  if (takeout === 'Yes') {
    return true;
  }

  return false;
};

export const shouldEnableOrderButtonTableSystem = (orderStatus = '') => {
  const pathName = window.location.pathname;
  if (orderStatus.toLocaleLowerCase() === 'pending') {
    return false;
  }
  
  if (pathName.match(/^\/order\/([0-9a-fA-F]{24})\/payment$/)) {
    return true;
  }

  if (pathName.match(/^\/order\/([0-9a-fA-F]{24})\/split-bill$/)) {
    return true;
  }

  return false;
};

export const getOrderSnapshotForPayment = (orderId) => {
  const orderSnapshots = JSON.parse(localStorage.getItem("orderSnapshots"));
  const snapshot = orderSnapshots.find((item) => item.orderId === orderId);

  return snapshot.data;
};

export const shouldBlinkATable = (activeOrders = []) => {
  if (activeOrders.length === 0) {
    return false;
  }

  return activeOrders.some((item) => item.orderStatus === "Pending");
};

export const isCleanableATable = (activeOrders = []) => {
  console.log('-----------isCleanableATable----------------', {activeOrders});
  
  if (activeOrders.length === 0) {
    return false;
  }

  // return !activeOrders.some((item) => item.orderStatus !== "Completed");
  return !activeOrders.some((item) => !["Completed", "Cancelled"].includes(item.orderStatus));
};

export const placeChairs = (count, side, chairWidth, chairHeight, chairOffset) => {
  const chairs = [];

  for (let i = 0; i < count; i++) {
    let style = {};
    const positionPercent = (100 / (count + 1)) * (i + 1);

    switch (side) {
      case "top":
        style = {
          top: `-${chairHeight / 2 + chairOffset}px`,
          left: `${positionPercent}%`,
          transform: `translateX(-50%) rotate(0deg)`,
        };
        break;
      case "bottom":
        style = {
          bottom: `-${chairHeight / 2 + chairOffset}px`,
          left: `${positionPercent}%`,
          transform: `translateX(-50%) rotate(180deg)`,
        };
        break;
      case "left":
        style = {
          left: `-${chairWidth / 2 + chairOffset}px`,
          top: `${positionPercent}%`,
          transform: `translateY(-50%) rotate(270deg)`,
        };
        break;
      case "right":
        style = {
          right: `-${chairWidth / 2 + chairOffset}px`,
          top: `${positionPercent}%`,
          transform: `translateY(-50%) rotate(90deg)`,
        };
        break;
      default:
        break;
    }
    chairs.push(style);
  }

  return chairs;
};

export const initOrderEditTableSession = (orderId, tables, orderType, isTableManagement) => {
  console.log('-----initOrderEditTableSession-------', {orderId, tables, orderType, isTableManagement});
  if (!isTableManagement || orderType === "Takeout") {
    return;
  }

  replaceSelectedTablesInStore(tables.map(i => ({...i, orderId})), true);
};


export function getFormatedTabItems(restaurantId, floors=[], allowMultiSelect = false) {
  if (floors.length === 0) return [];
  return floors.map((item) => {
    return {
      place_id: item.id,
      label: <LayoutTabsCustomLable title={item.name} tables={item.tables} />,
      key: item.id,
      children: (
        <DinningPlace
          restaurantId={restaurantId}
          floorPlanId={item.id}
          allowMultiSelect={allowMultiSelect}
          tableArray={item.tables}
        />
      ),
    };
  });
}

export const tableCleanRequestSubmit = async (token, notifier, restaurantId, floorId, tableId) => {
  try {
    const params = { restaurantId, floorId, tableId };

    const res = await ApiService.TABLE_CLEAN(params, token);

    if (!res || res.code !== 200) {
      notifier(res?.message || "Failed to clean table. Please, try again.");
      return;
    }

    notifier("Table cleaned successfully.", false);
  } catch (err) {
    notifier(err?.response?.data?.message || "Failed to clean table. Please, try again.");
  }
};

export const orderMergeRequest = async (token, notifier, orderIds) => {
  try {
    const res = await ApiService.MERGE_ORDER({orderIds}, token);

    if (!res || res.code !== 200) {
      notifier(res?.message || "Failed to merge order. Please, try again.");
      return {
        success: false,
        record: null
      };
    }

    notifier("Order merged successfully.", false);
    return {
      success: true,
      record: res.payload.record
    };
  } catch (err) {
    notifier(err?.response?.data?.message || "Failed to merge table. Please, try again.");
   return {
      success: false,
      record: null
    };
  }
};

export const hasMissingTable = (arr1, arr2) => {
  return arr1.some(item1 => 
    !arr2.some(item2 =>
      item2.floorId === item1.floorId &&
      item2.tableId === item1.tableId
    )
  );
}


export const orderTransferRequest = async (token, notifier, params) => {
  try {
    const res = await ApiService.TRANSFER_ORDER(params, token);

    console.log('*****res****', res);

    if (!res || res.code !== 200) {
      notifier(res?.message || "Failed to transfer order. Please, try again.");
      return {
        success: false,
        record: null
      };
    }

    notifier("Order transferred successfully.", false);
    return {
      success: true,
      record: null
    };
  } catch (err) {
    notifier(err?.response?.data?.message || "Failed to transger table. Please, try again.");
   return {
      success: false,
      record: null
    };
  }
};


export const updateGuestsRequest = async (token, notifier, params) => {
  try {
    const res = await ApiService.UPDATE_GUESTS(params, token);

    console.log('*****res****', res);

    if (!res || res.code !== 200) {
      notifier(res?.message || "Failed to update guests. Please, try again.");
      return {
        success: false,
        record: null
      };
    }

    notifier("Guests updated successfully.", false);
    return {
      success: true,
      record: null
    };
  } catch (err) {
    notifier(err?.response?.data?.message || "Failed to update guests. Please, try again.");
   return {
      success: false,
      record: null
    };
  }
};

export const fetchFloors = async (restaurantId, token) => {
  try {
    const res = await ApiService.GET_FLOOR_AND_TABLE_LAYOUT({restaurantId}, token);
    if (!res || res.code !== 200) {
        return {
          success: false,
          message: res?.message || "Failed to fetch restaurant branches",
          record: null
        };
      }

      return {
        success: true,
        message: '',
        record: res.payload.record
      };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Something went wrong!",
      record: null
    };
  }
}

export const fetchAndUpdateTableFloors = async(restaurantId, token) => {
  const result = await fetchFloors(restaurantId, token);

  if (result.success) {
    updateTableManagementStore(result.record.floors, result.record.statusSummary);
  }
}
